/**
 * pd-lazy-main.js
 * Lazy-loads main.js (Swiper bundle + site utilities) only when needed.
 * Pages without carousels or interactive widgets skip the 122KB download.
 *
 * - Carousel pages: loads when the first <swiper-carousel> enters viewport
 * - Pages with animated numbers, case study slides, etc.: loads on DOMContentLoaded
 * - Pages with none of the above: main.js never loads
 */
(function () {
  'use strict';

  var mainJsSrc = document.currentScript && document.currentScript.dataset.mainSrc;
  if (!mainJsSrc) return;

  var loaded = false;

  function loadMainJs() {
    if (loaded) return;
    loaded = true;
    var script = document.createElement('script');
    script.src = mainJsSrc;
    document.head.appendChild(script);
  }

  /* Selectors that depend on main.js (excluding menu-drawer, handled by global.js) */
  var UTIL_SELECTORS = [
    '.animated-number',
    '.case-study-slides__frames',
    '.filter-section',
    '[data-dropdown-trigger]'
  ];

  function pageNeedsMainJs() {
    for (var i = 0; i < UTIL_SELECTORS.length; i++) {
      if (document.querySelector(UTIL_SELECTORS[i])) return true;
    }
    return false;
  }

  /* Carousel pages: observe and load when first carousel nears the viewport */
  var carousels = document.querySelectorAll('swiper-carousel');
  if (carousels.length > 0) {
    if (!('IntersectionObserver' in window)) {
      loadMainJs();
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            loadMainJs();
            observer.disconnect();
            return;
          }
        }
      },
      { rootMargin: '200px' }
    );

    carousels.forEach(function (el) {
      observer.observe(el);
    });
    return;
  }

  /* Non-carousel pages: load on DOMContentLoaded only if utility selectors exist */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      if (pageNeedsMainJs()) loadMainJs();
    });
  } else {
    if (pageNeedsMainJs()) loadMainJs();
  }
})();
